@if(displayBinge()){
<div class="binge-container flex justify-end z-2"
    [ngClass]="{ 'translated': isMiniPlayer(),'mini-binge-container':isUiHidden() }">

    <div class="binge flex items-center px-5 cursor-pointer" [ngClass]="{ 'hidden': !displayBinge() }"
        (click)="playNextItem()">
        <div class="thumbnail" [transcodeImage]="nextItem()?.posterLandscape">
            <span class="countdown">{{ nextItemCountdown() }}</span>
        </div>
        <div class="binge-content ps-3 flex flex-col justify-between">
            <div class="flex justify-between items-center">
                <div class="play-next fw-semibold cursor-pointer">
                    {{'player.binge.play_next' | transloco }}</div>
                <rounded-icon-button class="relative" size="xxsmall" (onClick)="closeBinge($event)"
                    [transparentBackground]="true" [imgSrc]="skinning.getImage('icon_close')"></rounded-icon-button>
            </div>
            <div class="title font-light line-clamp-2">{{ nextItemTitle() }}</div>
        </div>
    </div>
</div>
}